import HTMLReactParser from 'html-react-parser';
import React, { createRef, useState } from 'react';
import { useFormContext } from "react-hook-form";
import { useTranslation } from 'react-i18next';
import { capitalize } from '../utils';
import FormInputTextareaRichEditor from './FormInputTextareaRichEditor';
import FormInputTextareaRichEditorWithReactHookForm from './FormInputTextareaRichEditorWithReactHookForm';

const RegistrationFormInput = ({
    inputType,
    onChange,
    name,
    required,
    placeholder,
    value,
    defaultValue,
    isRegister,
    inputOptions,
    accept = [".jpg", ".jpeg", ".png", ".pdf"],
    maxLength,
    helper
}) => {

    const { t, i18n } = useTranslation();

    const { register, watch } = useFormContext();
    const watchedValue = watch(name) || defaultValue || '';


    const [fileName, setFileName] = useState('');

    const handleChangeFileName = (event) => {
        setFileName(event.target.files[0].name);
    };


    switch (inputType) {

        case 'select': return <div className="form-checked" key={name}>
            <select className='w-full px-2 py-2 rounded border border-gray-300 dark:border-neutral-700 bg-white dark:bg-neutral-800 text-gray-800 dark:text-neutral-100' {...register(name, { required: required })}>
                {inputOptions && inputOptions.map((option, index) =>
                    <option key={index} value={option.value}>{option.label}</option>
                )}
            </select>
        </div>

        case 'radio': return <div className="form-check" key={name}>
            {inputOptions && inputOptions.map((option, index) =>
                <div className="form-check" key={index}>
                    <label className="form-check-label font-normal text-gray-700 dark:text-neutral-200">
                        <input
                            {...register(name, { required: required, onChange: (event) => { if (onChange) onChange(event); } })}
                            type="radio"
                            className="form-check-input"
                            value={option.value} />{` `}
                        {HTMLReactParser(option.label ?? "")}
                    </label>
                </div>
            )}
        </div>

        case 'checkbox': return <div className="form-check" key={name}>
            {inputOptions && inputOptions.map((option, index) =>
                <div className="form-check" key={index}>
                    <label className="form-check-label font-normal text-gray-700 dark:text-neutral-200">
                        <input
                            {...register(name, { required: required, onChange: (event) => { if (onChange) onChange(event); } })}
                            type="checkbox"
                            className="form-check-input"
                            value={option.value} />
                        {HTMLReactParser(option.label ?? "")}
                    </label>
                </div>
            )}
        </div>


        // case 'checkbox': return <div className="form-check">
        //     <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
        //     <label className="form-check-label" htmlFor="flexCheckDefault">
        //         {placeholder}
        //     </label>
        // </div>

        //case 'textarea': return <textarea  {...register(name, { required: required })} type="text" className="form-control" placeholder={placeholder ?? name}></textarea>

        //case 'textarea': return <FormInputTextareaRichEditor register={{ ...register(name, { required: required }) }} />

        case 'textarea': return isRegister ? <FormInputTextareaRichEditorWithReactHookForm
            onChange={onChange}
            name={name}
            fieldName={name}
            required={required}
            fieldValue={defaultValue} /> : <FormInputTextareaRichEditor
            onChange={onChange}
            name={name}
            fieldName={name}
            isRegister={isRegister} />


        case 'file____333': return <> <label for="files" className="form-label border rounded pe-5 ps-3 py-2 bg-light">{t('form.parcourir')}...</label>
            <input id="files"
                style={{ visibility: "hidden" }}
                type="file"
                {...register(name, { required: required })}
                className="form-control "
                accept=".jpg, .jpeg, .png"
                placeholder={placeholder ?? name} /></>

        case 'file': return <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
                <input
                    id={`input-file-${name}`}
                    {...register(name, { required: required })}
                    type="file"
                    className="sr-only"
                    accept={accept.map(item => `${item}`).join(',')}
                    onChange={handleChangeFileName}
                />
                <label
                    htmlFor={`input-file-${name}`}
                    className="cursor-pointer inline-flex items-center px-3 py-1.5 border border-gray-400 dark:border-neutral-500 rounded bg-gray-100 dark:bg-neutral-700 hover:bg-gray-200 dark:hover:bg-neutral-600 text-sm text-gray-700 dark:text-neutral-200 transition-colors"
                >
                    {t('form.parcourir')}
                </label>
                <span className="text-sm text-gray-500 dark:text-neutral-400 truncate max-w-[200px]">
                    {fileName || t('form.no_file_selected')}
                </span>
            </div>
            {defaultValue && <img src={defaultValue} className="h-16 w-16 rounded-xl object-contain border border-gray-200 dark:border-neutral-600" alt="" />}
        </div>



        case 'hidden': return <input  {...register(name, {
            required: required,
            value: defaultValue
        })}

            type="hidden"
            className="form-control rounded-pill"
            id={name}

            placeholder={placeholder ?? name} />

        case 'date': return <input {...register(name, { required: required, value: defaultValue })}
            type="date"
            className="w-full px-3 py-2 border border-gray-300 dark:border-neutral-700 rounded-2xl bg-white dark:bg-neutral-800 text-gray-800 dark:text-neutral-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
            id={name}
            placeholder={placeholder ?? name} />

        case 'number': return <input {...register(name, { required: required, value: defaultValue })}
            type="number"
            className="w-full px-3 py-2 border border-gray-300 dark:border-neutral-700 rounded-2xl bg-white dark:bg-neutral-800 text-gray-800 dark:text-neutral-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
            id={name}
            placeholder={placeholder ?? name} />

        default:
            // On récupère les props de register, y compris son propre onChange.
            const registrationProps = register(name, {
                required: required,
                value: defaultValue
            });

            // On crée un handler qui appelle l'onChange de react-hook-form PUIS celui passé en prop.
            const handleChange = (e) => {
                registrationProps.onChange(e); // Essentiel pour react-hook-form
                if (onChange) {
                    onChange(e); // Appelle l'onChange du parent s'il existe
                }
            };

            return (
                <div className="w-100 ">
                    <input
                        {...registrationProps}
                        onChange={handleChange}
                        maxLength={maxLength}
                        type="text"
                        className="w-full px-3 py-2 border border-gray-300 dark:border-neutral-700 rounded-2xl bg-white dark:bg-neutral-800 text-gray-800 dark:text-neutral-100 placeholder-gray-400 dark:placeholder-neutral-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        id={name}
                        placeholder={(placeholder ?? name).replace(/<[^>]*>/g, '')}
                    />
                    {maxLength && (
                        <div className="flex justify-between">
                            <small className="text-gray-400 dark:text-neutral-500 text-sm pt-2">{HTMLReactParser(helper ?? "")}</small>
                            <div className="justify-end flex">
                                <div className={`m-1 w-fit p-2 text-right text-sm pr-2 ${watchedValue.length >= maxLength ? 'text-red-500 bg-red-100 dark:bg-red-900/30 dark:text-red-400' : 'bg-green-300 dark:bg-green-800/40 text-gray-500 dark:text-neutral-300'}`}>
                                    {watchedValue.length} / {maxLength}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            );
    }
}

export default RegistrationFormInput;